import {createRouter, createWebHistory} from 'vue-router';
import routes from './routes';

export default createRouter({
  history: createWebHistory('/'),
  // scrollBehavior(to, from, savedPosition) {
  //   // https://router.vuejs.org/guide/advanced/scroll-behavior.html
  //   if (to.hash) { // Эмулируем переход к якорю. Тоесть если в ссылку добавить в конце хеш '#my-custom-cool-id', то страница автоматически прокрутится к этому элементу
  //     return {
  //       selector: to.hash,
  //     };
  //   }
  //   if (to.meta.handleScrollInComponent) return null;
  //   return savedPosition;
  // },
  routes,
});
